import React from 'react';
import BotmarkLogo from "../images/reactiveImages/Botmark_Logo_Trademark_High_Right_Res.png";

const Logo = (props) => {
  return (
    <img
        alt="Logo"
        height="75%"
        width="75%"
        src={BotmarkLogo}
        {...props}
    />
  );
};

export default Logo;
